import {
    createContext,
    useContext
} from "react";
import type {
    ToastStackContextType
} from "./type";

export const ToastStackContext = createContext<ToastStackContextType | null>(null);

export const useToastStackContext = (): ToastStackContextType | null => {
    return useContext(ToastStackContext);
};
